import { useMemo } from "react";
import {
  InternalAdminTagQuery,
  InternalAdminTagQueryVariables,
} from "gql/graphql";
import { useQuery } from "@apollo/client";
import INTERNAL_ADMIN_TAG_QUERY from "../_networking/internal-admin-tag";

const useInternalAdminTags = (id: string | string[] | undefined) => {
  const isValid = (Array.isArray(id) && id.length > 0) || !!id;

  const { data, loading } = useQuery<
    InternalAdminTagQuery,
    InternalAdminTagQueryVariables
  >(INTERNAL_ADMIN_TAG_QUERY, {
    fetchPolicy: "network-only",
    variables: id
      ? {
          id,
        }
      : undefined,
    skip: !isValid,
  });

  const tags = useMemo(() => {
    if (!data) return [];
    return data.internalAdminTag;
  }, [data]);

  const tag = useMemo(() => {
    if (tags && tags.length === 1) {
      return tags[0];
    }
    return undefined;
  }, [tags]);

  return {
    tag,
    tags,
    loading,
  };
};

export default useInternalAdminTags;
